module.exports = __webpack_public_path__ + "img/tit2.83977ed1.png";